import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { facebookLogin, facebookGetToken } from 'appSrc/redux/actions';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class FacebookLoginButton extends PureComponent {
    submitHandler = () => {
        return new Promise( ( resolve, reject ) => {
            if( this.props.facebookStatus != 'connected' ) {
                //user hasn't connected this app to facebook
                this.props.facebookLogin()
                .then( ( facebookResponse ) => {
                    if( facebookResponse.status == 'connected' ) {
                        resolve( { fbToken: facebookResponse.authResponse.accessToken } );
                    } else {
                        console.error( 'Can\'t connect with facebook' );
                        //TODO: some sort of error message because they aren't connecting w/ facebook
                        reject();
                    }
                } );
            } else {
                //user is already connected, get their token and pass it up
                this.props.facebookGetToken()
                .then( ( fbToken ) => {
                    resolve( { fbToken } );
                } );
            }
        } )
        .then( ( fbObj ) => {
            this.props.onSubmit( fbObj );
        } )
        .catch( () => {
            alert( 'Could\'t connect with Facebook' );
        } );
    }


    render() {
        return (
            <div className={ style.facebookSignUp }>
                <button className={ style.facebookButton } type='button' onClick={ this.submitHandler }>
                    <div className={ style.facebookIcon }>
                        <Icon source='fontAwesome' icon='fab/faFacebook' size={ 30 } />
                    </div>
                    <div className={ style.rightFacebookButton }>
                        { this.props.label }
                    </div>
                </button>
            </div>
        );
    }
}
FacebookLoginButton.propTypes = {
    onSubmit: PropTypes.func,
    label: PropTypes.string,
    facebookStatus: PropTypes.string,
    facebookLogin: PropTypes.func,
    facebookGetToken: PropTypes.func,
};
FacebookLoginButton.defaultProps = {
    onSubmit: () => {},
    onLogin: () => {},
    label: 'Login with Facebook',
};

const mapStateToProps = ( state ) => {
    return {
        facebookStatus: state.facebook.status,
        fetching: state.facebook.fetching,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        facebookLogin: () => {
            return dispatch( facebookLogin() );
        },
        facebookGetToken: () => {
            return dispatch( facebookGetToken() );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( FacebookLoginButton );
